module.exports = __webpack_public_path__ + "static/img/pick-path.61c7fcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pick-path.jpg
// module id = 1717
// module chunks = 2